import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {PublisherListFilter, PublishersService} from '../../services/publishers.service';
import { Observable } from 'rxjs';
import { AppsAutocompleteComponent } from './apps-autocomplete.component';
import { Apps } from '../../domain/apps.model';
import { AppsService } from '../../services/apps.service';
import { AppsTableStatusColorMap } from 'src/app/shared/domain/apps.model';
import { getAppDisplayLabel } from 'src/app/modules/supply-bundles/supply-bundle-form/fields/supply-bundle-publisher-apps.utils';

@Component({
  selector: 'ctv-app-autocomplete-chips',
  template: `
      <ctv-app-autocomplete #pc
                                  (appSelected)="onItemSelected($event)"
                                  [formFieldClass]="formFieldClass"
                                  [required]="required"
                                  [label]="placeholder"
                                  [floatLabel]="floatLabel"
                                  [formFieldAppearance]="formFieldAppearance ? formFieldAppearance : ''">
      </ctv-app-autocomplete>
      <mat-chip-list #chipList class="mt-n3" [ngClass]="[stacked ? 'mat-chip-list-stacked' : '', items.length > 0 ? 'mb-3' : '']" [hidden]="items.length < 1">
        <mat-basic-chip *ngFor="let item of items"
                        (removed)="remove(item)">
          <small class="fas fa-circle ml-n2 mr-2" ngClass="text-{{AppsTableStatusColorMap[item.status]}}"></small>
            {{ getAppLabel(item) }}
          <i class="fas fa-times-circle text-danger hand" matChipRemove></i>
        </mat-basic-chip>
      </mat-chip-list>
  `,
})
export class AppsAutocompleteChipsComponent implements OnInit {
  @ViewChild(AppsAutocompleteComponent, {static: true}) pc: AppsAutocompleteComponent;
  /** Pass clearFilterItems = new Subject<void>(); as Observable into it and then call clearFilterItems.next() to clear all the items*/
  @Input() clearItems: Observable<void>;
  @Input() public placeholder: string;
  @Input() public stacked: false;
  @Input() vbxOnly = false;
  @Input() public appIds: string[];
  @Input() public floatLabel: string;
  @Input() public formFieldClass: string;
  @Input() public formFieldAppearance: string;
  @Input() required = false;
  @Output() appSelectionChange = new EventEmitter<Apps[]>();

  public items: Apps[] = [];
  public readonly AppsTableStatusColorMap = AppsTableStatusColorMap;
  public readonly getAppLabel = getAppDisplayLabel;

  constructor(private service: AppsService) {
  }

  ngOnInit(): void {
    if (this.appIds && this.appIds.length) {
      //On parent component reload if there is single preselected item, it will actually be passed as string instead of a list
      if (typeof this.appIds === 'string') {
        this.appIds = [this.appIds];
      }
      //Fetch only preselected publishers
      this.service.getApps({ids: this.appIds}).subscribe(apps => {
        apps.content.map(app => {this.items.push(app);});
        this.pc.updateFilteredApps(this.items);
      });
    }
    this.clearItems?.subscribe(() => this.clearFilter());
  }

  onItemSelected($event: Apps) {
    if ($event) {
      this.items.push($event);
      this.appSelectionChange.emit(this.items);
      this.pc.resetInput();
      this.pc.updateFilteredApps(this.items);
    }
  }

  remove(app: Apps) {
    this.items.splice(this.items.indexOf(app), 1);
    this.appSelectionChange.emit(this.items);
    this.pc.updateFilteredApps(this.items);
  }

  /** Clear all items from filter. */
  clearFilter(){
    this.items = [];
    this.pc.updateFilteredApps(this.items);
  }

  disableFilter(disable: boolean) {
    if (disable) {
      this.pc.disable();
    }
    else {
      this.pc.enable();
    }
  }
}
